import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function SiteLayout({ onEnquiry }) {
  return (
    <>
      <Header onEnquiry={onEnquiry} />
      <Outlet />
      <Footer onEnquiry={onEnquiry} />
    </>
  );
}
